import { css } from "@stubhub/broadway-foundation/css";
import { shimmerBase } from "../LazyCarouselSection/carousel-skeleton.recipes";

// Clear hero banner placeholder — mirrors HeroContainer in
// clear-hero-banner/styled-components.ts (bannerHeights + addBannerMargin with
// narrowTopMargin, the prop HeroBanner passes).
export const clearBannerSkeleton = css({
  ...shimmerBase,
  width: "full",
  maxWidth: "[1200px]",
  height: "[260px]",
  marginBlockStart: "primitives.50",
  marginBlockEnd: "primitives.0",
  marginInlineStart: "primitives.200",
  marginInlineEnd: "primitives.200",
  tablet: {
    height: "[376px]",
    marginBlockStart: "primitives.300",
  },
  desktop: {
    height: "[432px]",
    marginBlockStart: "primitives.0",
    marginInlineStart: "primitives.400",
    marginInlineEnd: "primitives.400",
  },
});

// Marquee hero placeholder — mirrors MarqueeHeroCarousel: heading, container
// top margin (marquee-hero-carousel.recipes.ts), and marquee GridCardBase
// entries (210×325 mobile / 288×352 tablet+, see grid-card-base/utils.ts and
// resolveCarouselEntrySize).
export const marqueeSkeletonContainer = css({
  width: "full",
  overflowX: "hidden",
  overflowY: "hidden",
});

export const marqueeSkeletonTitle = css({
  ...shimmerBase,
  height: "[28px]",
  width: "[240px]",
});

export const marqueeSkeletonRow = css({
  display: "flex",
  columnGap: "primitives.150",
  rowGap: "primitives.150",
  marginBlockStart: "primitives.250",
  tablet: {
    columnGap: "primitives.200",
    rowGap: "primitives.200",
    marginBlockStart: "primitives.300",
  },
});

export const marqueeSkeletonCard = css({
  ...shimmerBase,
  flexGrow: 0,
  flexShrink: 0,
  flexBasis: "auto",
  width: "[210px]",
  height: "[325px]",
  borderStartStartRadius: "primitives.150",
  borderStartEndRadius: "primitives.150",
  borderEndStartRadius: "primitives.150",
  borderEndEndRadius: "primitives.150",
  tablet: {
    width: "[288px]",
    height: "[352px]",
  },
});
